import BigNumber from 'bignumber.js';
import { RequestConfig, useRequest } from '../api/hooks';
import { EditorInfo, GMTInfo, Toggle } from './common';
import { OrderDeliveryTypeConfig } from './order';
import dayjs from 'dayjs';

export const PoiConfigEndpoint = `/poiConfig`;

export interface PoiConfig {
  freightChargeBase: number;
  freightChargeFreeAmountLimit: number;
  freightPerKg: number;
  orderPayTimeout: number;
  orderConfirmTimeout: number;
  deliveryTypesConfig: {
    [key: string]: OrderDeliveryTypeConfig;
  };

  rechargeConfig: {
    enabled: Toggle;
    discountType: RechargeDiscountType;
    // matchAmount?: number;
    // plusAmount?: number;

    // 满额送 规则
    amountPlusAmount?: { matchAmount: number; plusAmount: number }[];

    // 每满额送 规则
    amountPlusAmountMulti?: { perMatchAmount: number; plusAmount: number; plusLimit: number };
    amountPlusAmountMultiPresets?: number[];
  };

  /* 最多可预订天数 */
  maxBookableDays: number;
  /* 最近可预订天数, 0: 最早可预订今天， 1： 最早可预订明天 */
  latestBookableDays: number;
  /* 可预约最小单位(分钟) */
  minBooksLength: number;
  /* 单位时间最多可预约 */
  maxStockPerSlot: number;
  /*相较当前，至少提前预约时间(分钟) */
  earliestBookingTimeFromNow: number;
  /*一天中最早可预订时间 */
  earliestBookingTime: dayjs.Dayjs;
  /*一天中最晚可预订时间 */
  latestBookingTime: dayjs.Dayjs;
}

// export enum BalanceLogTypeEnum {
//   Recharge_In_Store = 1,
//   Consume_In_Store = 2,
//   Order_Refund = 3,
//   Recharge_In_Weapp = 4,
//   Consume_In_Weapp = 5,
// }

export interface BalanceLog extends GMTInfo, EditorInfo {
  id: number;
  userId: number;
  poiId: number;
  orderSn: string;
  value: number;
  cost: number;
  after: number;
  type: number;
  typeDesc: string;
  comment: string;
}

export enum RechargeDiscountType {
  OFF,

  // 满额送
  Amount_PLUS_Amount,

  // 每满额送
  Amount_PLUS_Amount_Multi,
}

export const useRequestPoiConfig = (config: RequestConfig = {}) =>
  useRequest<PoiConfig>(
    {
      method: 'get',
      url: `${PoiConfigEndpoint}`,
    },
    config
  );

export const useRequestSavePoiConfig = () =>
  useRequest<PoiConfig>(
    {
      method: 'put',
      url: `${PoiConfigEndpoint}`,
    },
    {
      manual: true,
    }
  );

export const useRequestSaveRechargeConfig = () =>
  useRequest<PoiConfig>(
    {
      method: 'put',
      url: `${PoiConfigEndpoint}/recharge`,
    },
    {
      manual: true,
    }
  );

export const getPlusAmount = (rechargeConfig: PoiConfig['rechargeConfig'], actualPrice: number) => {
  if (rechargeConfig.discountType === RechargeDiscountType.Amount_PLUS_Amount) {
    const discountArr = rechargeConfig.amountPlusAmount;
    let plus = 0;
    for (let i = discountArr.length - 1; i >= 0; i--) {
      if (actualPrice >= discountArr[i].matchAmount) {
        plus = discountArr[i].plusAmount;
        break;
      }
    }
    return plus;
  } else if (rechargeConfig.discountType === RechargeDiscountType.Amount_PLUS_Amount_Multi) {
    const rule = rechargeConfig.amountPlusAmountMulti;
    let plus = new BigNumber(actualPrice)
      .dividedToIntegerBy(rule.perMatchAmount)
      .multipliedBy(rule.plusAmount)
      .toNumber();
    if (rule.plusLimit) {
      plus = Math.min(plus, rule.plusLimit);
    }
    return plus;
  }
  return 0;
};
